import { render, staticRenderFns } from "./KpiWithPointsLegend.vue?vue&type=template&id=0ce68776&scoped=true&"
import script from "./KpiWithPointsLegend.vue?vue&type=script&lang=js&"
export * from "./KpiWithPointsLegend.vue?vue&type=script&lang=js&"
import style0 from "./KpiWithPointsLegend.vue?vue&type=style&index=0&id=0ce68776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce68776",
  null
  
)

export default component.exports